// extracted by mini-css-extract-plugin
export default {"nftHolder":"tU_HQDE0_RAJufiNs2v5","nftHolderBalance":"V5XhD3ax5_4LGXAYPAE3"};